import * as React from 'react';
import { AlertModal } from '@repo/ui/components';

export interface ICancelOrderModalProps {
  show: boolean;
  isOrder: boolean;
  onConfirm(confirmed: boolean): void;
}

export const CancelOrderModal = (props: ICancelOrderModalProps) => {
  if (!props.show) return null;

  const cancelOrderModalData = {
    title: `Er du sikker på at du vil ${props.isOrder ? 'kansellere ordren' : 'slette tilbudet'}?`,
    description: 'Denne handlingen kan ikke angres',
    actionsList: [
      {
        actionLabel: 'Bekreft',
        actionMethod: () => props.onConfirm(true),
        actionClassNames:
          'font-bold py-[1.125rem] px-[1.875rem] leading-[100%] text-black hover:text-white border-[3px] border-darkBlue focus:border-darkBlue bg-white enabled:hover:bg-darkBlue focus:ring-0',
      },
      {
        actionLabel: 'Avbryt',
        actionMethod: () => props.onConfirm(false),
        actionClassNames:
          'font-bold py-[18px] px-[30px] leading-[100%] bg-darkBlue enabled:hover:bg-darkNavyBlue text-white border-none',
      },
    ],
    hideIcon: true,
  };

  return (
    <AlertModal
      className="w-fit"
      open={props?.show}
      onCloseClick={() => props.onConfirm(false)}
      title={cancelOrderModalData.title}
      description={cancelOrderModalData.description}
      actionsList={cancelOrderModalData.actionsList}
    />
  );
};
